export function formatErrorResponse(responseData) {
  const errors = (responseData.error ? {error: [responseData.error]} : responseData.errors) || (responseData.data && responseData.data.errors) || {};
  const message = responseData.message || (responseData.data && responseData.data.message) || 'Something went wrong.';

  const errorsArray = [].concat.apply([], Object.values(errors));
  return [message].concat(...errorsArray).join(' ');
}
